import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const PaymentMode = React.lazy(() =>
    import('../PaymentMode')
);
const paymentModeRoutesRegistry = [
    {
        path: PAGE_URL.PAYMENT_MODE_PAGE,
        element: <PaymentMode />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default paymentModeRoutesRegistry;
